import { render } from "./AuthorMessagePart.vue?vue&type=template&id=8d68a73a"
import script from "./AuthorMessagePart.vue?vue&type=script&lang=ts"
export * from "./AuthorMessagePart.vue?vue&type=script&lang=ts"
script.render = render

export default script